import styled from "styled-components"

export const AddressInfosBlockContainer = styled.div`
  margin-top: 10px;
`

export const AddressInfosBlockSpan = styled.span`
  font-weight: 600;
`
